
















import Vue from 'vue'
import XInput from './XInput.vue'

export default Vue.extend({
  inheritAttrs: false,
  name: 'XPasswordInput',
  components: { XInput },
  props: {
    rules: {
      type: [String, Object],
      required: false,
    },
    checkFormat: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      visible: false,
    }
  },
  computed: {
    computedRules(): string {
      return `required${this.checkFormat ? '|password' : ''}${
        this.rules ? '|' + this.rules : ''
      }`
    },
  },
  methods: {
    onClickVisible() {
      this.visible = !this.visible
    },
  },
})
